import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-list-main"
}
const _hoisted_2 = {
  key: 0,
  class: "-wrap"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_6 = { class: "-cred" }
const _hoisted_7 = { class: "-cred" }
const _hoisted_8 = {
  key: 0,
  class: "-list-bottom"
}
const _hoisted_9 = {
  key: 0,
  class: "-list-bottom-left"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除选中")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("添加")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return ($setup.list)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          class: "-list-search",
          ref: "_listForm",
          model: $setup.list.search
        }, {
          default: _withCtx(() => [
            ($setup.setting.openSearch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_el_form_item, { prop: "orderNo" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "订单编号搜索",
                        modelValue: $setup.list.search.orderNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.list.search.orderNo) = $event)),
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { prop: "title" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "订单描述搜索",
                        modelValue: $setup.list.search.title,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.list.search.title) = $event)),
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { class: "-wa" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        "native-type": "submit",
                        icon: "icSearch",
                        loading: $setup.list.searching,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx._listSearch()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["loading"]),
                      _createVNode(_component_el_button, {
                        plain: "",
                        icon: "icRefresh",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx._listSearchReset()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            ($setup.setting.openAdd)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  class: "-button-add",
                  type: "primary",
                  icon: "icPlus",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx._listShowAdd()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"]),
        _withDirectives(_createVNode(_component_el_table, {
          class: "-list-table -scroll-x",
          data: $setup.list.data,
          "max-height": $setup.setting.tableHeight,
          onSelectionChange: _ctx._listSelectionChange,
          ref: "_listTable",
          stripe: "",
          "header-cell-class-name": "-list-th",
          "cell-class-name": "-list-td",
          "highlight-current-row": true,
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "orderNo",
              label: "订单编号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "产品信息"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", null, "名称：" + _toDisplayString(scope.row.title), 1),
                _createElementVNode("div", null, "规格：" + _toDisplayString(scope.row.productStandard), 1),
                _createElementVNode("div", null, "类型：" + _toDisplayString($setup._model.options.orderType.getOptionLabel(scope.row.orderType)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "订单信息" }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", null, "数量：" + _toDisplayString(scope.row.totalBuy), 1),
                _createElementVNode("div", null, "合计：" + _toDisplayString(scope.row.totalStandardFee), 1),
                _createElementVNode("div", _hoisted_6, "实付：" + _toDisplayString(scope.row.totalPayFee), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "订单状态" }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup._model.options.state.getOptionLabel(scope.row.state)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "remark",
              label: "用户备注",
              width: "300"
            }),
            _createVNode(_component_el_table_column, {
              prop: "payTime",
              label: "支付时间",
              width: "100"
            })
          ]),
          _: 1
        }, 8, ["data", "max-height", "onSelectionChange"]), [
          [_directive_loading, $setup.list.searching]
        ]),
        ($setup.setting.openBottom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              ($setup.setting.openQuick)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    ($setup.setting.openDeleteBatch)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "danger",
                          size: "small",
                          icon: "icDelete",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx._listDeleteBatch()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ($setup.setting.openAdd)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "small",
                          icon: "icPlus",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx._listShowAdd()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              ($setup.setting.openPagination)
                ? (_openBlock(), _createBlock(_component_el_pagination, {
                    key: 1,
                    "page-size": $setup.list.size,
                    total: $setup.list.total,
                    onSizeChange: _ctx._listChangeSize,
                    onCurrentChange: _ctx._listChangeIndex,
                    "current-page": $setup.list.index,
                    "page-sizes": [10, 15, 20, 30, 50, 100],
                    "pager-count": "6",
                    layout: "total, sizes, prev, pager, next, jumper"
                  }, null, 8, ["page-size", "total", "onSizeChange", "onCurrentChange", "current-page"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}